import React, { useEffect, useState } from 'react'
import meetIntroStyle from 'styles/meetIntroduction.module.scss'
import DeviceId from 'utils/detectDevice'
import { domainName } from 'utils/parseDomain'
import { appTitle, appDomain } from 'utils/displayText'

const MeetIntro = props => {
  const [utmMedium, setUtmMedium] = useState('desktop')
  useEffect(() => {
    const platform = DeviceId.isDesktop() ? 'desktop' : 'mobile'
    setUtmMedium(platform)
  }, [])

  const {
    data: {
      airtable: {
        fields: { androidAppStore, iphoneAppStore },
      },
    },
  } = props

  const {
    data: {
      airtable: {
        data: { matrimonialDb },
      },
    },
  } = props

  const title = appTitle(matrimonialDb)

  return (
    <div className={meetIntroStyle.meetWrapper}>
      <div className={meetIntroStyle.meetHeading}>Introducing Shaadi Meet!</div>
      <div className={meetIntroStyle.meetInfoWrapper}>
        <img
          className={meetIntroStyle.meetImg}
          alt="meet"
          src="https://img2.shaadi.com/assests/2020/images/Home-Couple-Optimized.png"
        />
        <div className={meetIntroStyle.meetDetailWrapper}>
          <div className={meetIntroStyle.meetBannerWrapper}>
            <img
              alt="meetBanner"
              className={meetIntroStyle.meetBannerImg}
              src="https://img2.shaadi.com/assests/2020/images/meet-badge.svg"
            />
            <img
              className={meetIntroStyle.newTag}
              alt="newTag"
              src="https://img2.shaadi.com/assests/2020/images/New.svg"
            />
          </div>
          <div className={meetIntroStyle.meetIntroText}>
            {'Now meet your Matches over\nvideo call'}
          </div>
          <div className={meetIntroStyle.seperator} />
          <img
            alt="meetImage"
            className={meetIntroStyle.meetImgSD}
            src="https://img2.shaadi.com/assests/2020/images/Home-Couple-Optimized.png"
          />
          <div className={meetIntroStyle.downloadAppInfo}>
            <div className={meetIntroStyle.downloadTitle}>
              Available on the {appDomain()} App
            </div>
            <div className={meetIntroStyle.downloadSource}>
              <a
                href={`${androidAppStore}&referrer=utm_source=${domainName}&utm_medium=${utmMedium}&utm_campaign=android-app-shaadi-meet`}
                rel="noopener noreferrer"
                title={title}
                target="_blank"
              >
                <img
                  className={meetIntroStyle.androidDownload}
                  alt="playstore"
                  src="https://img2.shaadi.com/assests/2020/images/google-play-badge.svg"
                />
              </a>
              <a
                href={iphoneAppStore}
                rel="noopener noreferrer"
                title={title}
                target="_blank"
              >
                <img
                  className={
                    (meetIntroStyle.newDownloadAppIos,
                    meetIntroStyle.iosDownload)
                  }
                  alt="appstore"
                  src="https://img2.shaadi.com/assests/2020/images/apple-store-badge.svg"
                />
              </a>
            </div>
            <div>
              {DeviceId.isAndroid() && (
                <a
                  className={meetIntroStyle.downloadAppLink}
                  href={`${androidAppStore}&referrer=utm_source=${domainName}&utm_medium=${utmMedium}&utm_campaign=android-app-shaadi-meet`}
                  rel="noopener noreferrer"
                  title={title}
                  target="_blank"
                >
                  <img
                    alt="playstore"
                    src="https://img2.shaadi.com/assests/2020/images/google-play-badge.svg"
                  />
                </a>
              )}
              {DeviceId.isIos() && (
                <a
                  className={meetIntroStyle.downloadAppLink}
                  href={iphoneAppStore}
                  rel="noopener noreferrer"
                  title={title}
                  target="_blank"
                >
                  <img
                    className={meetIntroStyle.newDownloadAppIos}
                    alt="appstore"
                    src="https://img2.shaadi.com/assests/2020/images/apple-store-badge.svg"
                  />
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MeetIntro
